import actions from '@/store/modules/printLabel/actions';
import mutations from '@/store/modules/printLabel/mutations';
import getters from '@/store/modules/printLabel/getters';

const state = {
  printLabelInfo: null,
  loading: false,
  error: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
